import { render } from "./UserList.vue?vue&type=template&id=28c325b8&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=28c325b8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c325b8"]])

export default __exports__